// Design tokens untuk redesign UI Eighteen Media
// Base: putih/abu muda, aksen biru (primary), gold dipakai sparingly

export const colors = {
  bgPage: '#F9FAFB',
  bgCard: '#FFFFFF',
  bgCardMuted: '#F3F4F6',
  border: '#E5E7EB',
  borderStrong: '#D1D5DB',

  textPrimary: '#111827',
  textSecondary: '#6B7280',
  textMuted: '#9CA3AF',

  accent: '#2563EB',
  accentMuted: '#EFF6FF',
  accentText: '#1D4ED8',

  gold: '#D4A537',
  goldMuted: '#FEF9EC',
  goldText: '#92650B',

  success: '#059669',
  successMuted: '#ECFDF5',
  warning: '#D97706',
  warningMuted: '#FFFBEB',
  danger: '#DC2626',
  dangerMuted: '#FEF2F2',
};

export const radius = {
  sm: '8px',
  md: '10px',
  lg: '12px',
};

export const shadow = {
  card: '0 1px 2px rgba(0,0,0,0.04)',
};

export const styles = {
  page: {
    background: colors.bgPage,
    minHeight: '100vh',
    color: colors.textPrimary,
  },
  card: {
    background: colors.bgCard,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.lg,
    padding: '20px',
    boxShadow: shadow.card,
  },
  cardMuted: {
    background: colors.bgCardMuted,
    borderRadius: radius.md,
    padding: '16px',
  },
  buttonPrimary: {
    background: colors.accent,
    color: '#FFFFFF',
    border: 'none',
    borderRadius: radius.sm,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  buttonSecondary: {
    background: colors.bgCard,
    color: colors.textPrimary,
    border: `1px solid ${colors.borderStrong}`,
    borderRadius: radius.sm,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  badgeSuccess: {
    background: colors.successMuted,
    color: colors.success,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
  badgeWarning: {
    background: colors.warningMuted,
    color: colors.warning,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
  badgeDanger: {
    background: colors.dangerMuted,
    color: colors.danger,
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '20px',
  },
};
